export default "__VITE_ASSET__2f52302e__"